import Alpine from 'alpinejs'

import './components/timezone-date.js'
import './components/multi-currency.js'
import './stores/timezone.js'
import './stores/currency.js'

window.Alpine = Alpine
Alpine.start()